import React, { useState, useCallback } from "react";
import { AppointmentsProvider, useAppointmentsContext } from "../../context/AppointmentsContext";
import TabNavigation, {
  AppointmentViewType,
} from "../TabNavigation/TabNavigation";
import DailyView from "../DailyView/DailyView";
import WeeklyView from "../WeeklyView/WeeklyView";
import MonthlyView from "../MonthlyView/MonthlyView";
import { getStoredCalendarState, setStoredCalendarState } from "../../utils/calendarStorage";
import styles from "../../appointmentsPage.module.css";
import { tWithKeyAttr as t } from "../../../../i18nHelper";

/**
 * Inner component that consumes the context
 */
const AppointmentsContent: React.FC = () => {
  const [currentView, setCurrentViewState] = useState<AppointmentViewType>(() => {
    const stored = getStoredCalendarState();
    return (stored?.view as AppointmentViewType) ?? "daily";
  });

  const setCurrentView = useCallback((view: AppointmentViewType) => {
    setCurrentViewState(view);
    setStoredCalendarState({ view });
  }, []);
  const { searchTerm, setSearchTerm } = useAppointmentsContext();

  return (
    <div className={styles.container}>
      {/* Search Bar - Global for all views */}
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-start' }}>
        <div style={{ position: 'relative', width: '100%', maxWidth: '300px' }}>
          <span style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>🔍</span>
          <input
            type="text"
            placeholder={t("APPOINTMENTS_SEARCH_THERAPIST") || "חפש מטפל..."}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 35px 10px 10px',
              borderRadius: '8px',
              border: '1px solid #E5E7EB',
              fontSize: '14px',
              outline: 'none',
              boxSizing: 'border-box'
            }}
          />
        </div>
      </div>

      {/* Tab Navigation */}
      <TabNavigation activeTab={currentView} onTabChange={setCurrentView} />

      {/* Active View Content */}
      <div className={styles.viewContent}>
        {currentView === "daily" && <DailyView />}
        {currentView === "weekly" && <WeeklyView />}
        {currentView === "monthly" && <MonthlyView />}
      </div>
    </div>
  );
};

/**
 * Appointments Advanced View - Therapist Version
 *
 * Main wrapper for the advanced appointments calendar
 * Manages tabs between Daily, Weekly, Monthly views
 */
const AppointmentsAdvancedView: React.FC = () => {
  return (
    <AppointmentsProvider>
      <AppointmentsContent />
    </AppointmentsProvider>
  );
};

export default AppointmentsAdvancedView;
